import { lazy, Suspense } from "react";
import "./App.css";
import Thanks from "./pages/thanks"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
const Home = lazy(() => import("./pages/Home"));

const App = () => {
  return (
    <BrowserRouter>
      <Suspense>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/thank-you" element={<Thanks />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
export default App;
